import React from 'react';
import { StyleSheet, View } from 'react-native';
import Colors from '../../constants/Colors';
import Plentiful from '../../constants/Plentiful';
import ExternalLink from '../ExternalLink';
import NavBar from '../NavBar';
import MenuItem from '../MenuItem';
import { useNavigation } from '@react-navigation/native';
import { useLocalization } from '../../store/utils/useLocalization';

export default function HelpAndSupport() {
  const navigation = useNavigation();
  const { t } = useLocalization();

  return (
    <View style={styles.container}>
      <NavBar title={t('help_and_support')} onPressBack={() => navigation.navigate('landing')} />
      <View style={styles.mainContent}>
        <View style={styles.card}>
          <ExternalLink to="https://www.plentiful.org/#843" hrefAttrs={{ target: 'blank' }}>
            <MenuItem
              name={t('frequently_asked_questions')}
              description="Plentiful.org"
              icon="open-outline"
            />
          </ExternalLink>
          <ExternalLink to={`mailto:${Plentiful.SUPPORT_EMAIL}`}>
            <MenuItem name={t('contact_support')} description={Plentiful.SUPPORT_EMAIL} icon="open-outline" />
          </ExternalLink>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    flex: 1,
    alignItems: 'center',
  },
  mainContent: {
    flex: 1,
    maxWidth: 720,
    width: '100%',
  },
  card: {
    borderBottomColor: Colors.grayBorder,
    borderBottomWidth: 1,
    backgroundColor: Colors.white,
  },
});
